/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_In_FailedInputs */

const fr_auth_sign_in_failed = /** @type {(inputs: Auth_Sign_In_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion impossible. Réessayez ou contactez un administrateur si le problème persiste.`)
};

const en_auth_sign_in_failed = /** @type {(inputs: Auth_Sign_In_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not sign in. Try again, or contact an administrator if this continues.`)
};

/**
* | output |
* | --- |
* | "Could not sign in. Try again, or contact an administrator if this continues." |
*
* @param {Auth_Sign_In_FailedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_sign_in_failed = /** @type {((inputs?: Auth_Sign_In_FailedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_In_FailedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_sign_in_failed(inputs)
	return fr_auth_sign_in_failed(inputs)
});